(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vison-countdown-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-vison-countdown]';

    function initializeCountdown(root) {
      if (!root || root.dataset.countdownInitialized === 'true') return;

      root.dataset.countdownInitialized = 'true';

      const timeElement = root.querySelector('[data-vison-countdown-time]');
      const durationSeconds = Number.parseInt(root.dataset.durationSeconds, 10);
      const storageKey = root.dataset.storageKey;

      if (!timeElement || !Number.isFinite(durationSeconds) || durationSeconds < 1) {
        return;
      }

      const durationMs = durationSeconds * 1000;
      let timeoutId = null;
      let blinkIntervalId = null;
      let isBlinking = false;

      function readStoredEndTime() {
        try {
          const value = Number.parseInt(sessionStorage.getItem(storageKey), 10);
          return Number.isFinite(value) ? value : null;
        } catch (error) {
          return null;
        }
      }

      function storeEndTime(value) {
        try {
          sessionStorage.setItem(storageKey, String(value));
        } catch (error) {
          // O cronômetro continua funcionando sem armazenamento.
        }
      }

      function createNewEndTime() {
        const value = Date.now() + durationMs;
        storeEndTime(value);
        return value;
      }

      let endTime = readStoredEndTime();

      if (!endTime) {
        endTime = createNewEndTime();
      }

      function formatRemainingTime(milliseconds) {
        const totalSeconds = Math.max(0, Math.ceil(milliseconds / 1000));
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
      }

      function restartCountdown() {
        isBlinking = false;
        timeElement.classList.remove('is-hidden');
        endTime = createNewEndTime();
        updateCountdown();
      }

      function blinkAtZero() {
        if (isBlinking) return;

        isBlinking = true;
        window.clearTimeout(timeoutId);
        timeElement.textContent = '00:00';
        timeElement.classList.remove('is-hidden');

        let toggles = 0;

        blinkIntervalId = window.setInterval(() => {
          timeElement.classList.toggle('is-hidden');
          toggles += 1;

          if (toggles === 6) {
            window.clearInterval(blinkIntervalId);
            blinkIntervalId = null;
            restartCountdown();
          }
        }, 400);
      }

      function updateCountdown() {
        if (isBlinking) return;

        const remainingMs = endTime - Date.now();

        if (remainingMs <= 0) {
          blinkAtZero();
          return;
        }

        timeElement.textContent = formatRemainingTime(remainingMs);
        timeoutId = window.setTimeout(updateCountdown, 250);
      }

      function refreshWhenVisible() {
        if (!document.hidden && !isBlinking) {
          window.clearTimeout(timeoutId);
          updateCountdown();
        }
      }

      document.addEventListener('visibilitychange', refreshWhenVisible);
      updateCountdown();

      root.countdownCleanup = () => {
        window.clearTimeout(timeoutId);
        window.clearInterval(blinkIntervalId);
        document.removeEventListener('visibilitychange', refreshWhenVisible);
      };
    }

    function initializeAllCountdowns(container = document) {
      if (container.matches && container.matches(SELECTOR)) {
        initializeCountdown(container);
      }

      container.querySelectorAll(SELECTOR).forEach(initializeCountdown);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAllCountdowns());
    } else {
      initializeAllCountdowns();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAllCountdowns(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.querySelector(SELECTOR);

      if (root && typeof root.countdownCleanup === 'function') {
        root.countdownCleanup();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
